import { makeObservable, observable } from "mobx";
import Element from "./Element";

export default class ChartElement extends Element {
  constructor() {
    super();
    makeObservable(this);
  }

  @observable option = {};
}
